import React from "react";
import { Link } from "gatsby";
import { LocaleConsumer } from "../Layout";
import locales from "../../../config/i18n";

const LocalizedLink = ({ to, activeClassName, type, ...props }) => (
  <LocaleConsumer>
    {({ locale, alias }) => {
      const isIndex = to === "/";
      const path =
        typeof locales[locale] !== "undefined" && locales[locale].default
          ? to
          : `/${typeof alias !== "undefined" ? alias : locales[locale].path}${
              isIndex ? "/" : to
            }`;
      return (
        <>
          {type === undefined && (
            <Link
              {...props}
              to={path}
              activeClassName={activeClassName}
              partiallyActive={true}
              aria-label="TDCX"
            />
          )}
          {type === "external" && (
            <a {...props} aria-label="TDCX" href={to} target="_blank" />
          )}
        </>
      );
    }}
  </LocaleConsumer>
);

export default LocalizedLink;
